<!-- eslint-disable prettier/prettier -->
<template>
  <div class="box" @click="boxClick" v-if="!meta.HeaderBox">
    <div class="heardes">
      <div class="heardeBox">
        <div class="heardes-left">
          <span v-if="!token" class="heardes-text" @click="login(1)">登录</span>
          <span v-if="!token" class="heardes-text" @click="login(3)">注册</span>
          <span v-if="token" class="heardes-text">
            {{ userInfo.nickname }}</span
          >
          <span v-if="token" class="heardes-text" @click="exit()">退出</span>
        </div>
        <div class="heardes-right">
          <span class="heardes-text" @click="Jump('/my', { index: 2 })"
            >我的收藏</span
          >
          <span class="heardes-text" @click="Jump('/reserve', { index: 2 })"
            >我的会员</span
          >
          <span class="heardes-text" @click="Jump('/reserve', { index: 2 })"
            >帮助中心</span
          >
          <span class="heardes-text" @click="Jump('/my', { index: 0 })"
            >我的室外境教</span
          >
          <div
            v-if="QRofficialAccount.length !== 0"
            class="heardes-text heardes-text-img"
            @mouseenter="offmouseenter(true)"
            @mouseleave="offmouseenter(false)"
          >
            社群<img
              src="@/assets/images/home/theEarth.png"
              alt=""
              class="heardes-icon"
            />
            <img
              v-show="offmouseenterShow"
              :src="QRofficialAccount | imgFilter"
              alt=""
              class="officialAccount"
            />
          </div>
          <!-- <div
            class="heardes-text heardes-text-img"
            @mouseenter="offdownload(true)"
            @mouseleave="offdownload(false)"
          >
            手机APP【稚旅】
            <img
              v-show="offdownloadShow"
              src="https://oss.jiahuiku.cn/html/mobile/prod/20250730165652/img/download.a9bf6aa9.jpg"
              alt=""
              class="officialAccount"
            />
          </div> -->
          <div
            v-if="QRsmallProgram.length !== 0"
            class="heardes-text-img"
            @mouseenter="smallProgram(true)"
            @mouseleave="smallProgram(false)"
          >
            <img
              src="@/assets/images/home/iconwb.png"
              alt=""
              class="icon-item"
            />
            <img
              v-show="smallProgramShow"
              :src="QRsmallProgram | imgFilter"
              alt=""
              class="officialAccount smallProgram"
            />
          </div>
          <div
            v-if="QRweixing.length !== 0"
            class="heardes-text-img"
            @mouseenter="offmouseenterV2(true)"
            @mouseleave="offmouseenterV2(false)"
          >
            <img
              src="@/assets/images/home/icon_xcx.png"
              alt=""
              class="icon-item"
              style="width: 14px; height: 14px"
            />
            <img
              v-show="offmouseenterShow2"
              :src="QRweixing | imgFilter"
              alt=""
              class="officialAccount"
            />
          </div>
          <div
            v-if="QRcustomized.length !== 0"
            class="heardes-text-img"
            @mouseenter="smallProgramV2(true)"
            @mouseleave="smallProgramV2(false)"
          >
            <img
              src="@/assets/images/home/icon_gzh.png"
              alt=""
              class="icon-item"
            />
            <img
              v-show="smallProgramShow2"
              :src="QRcustomized | imgFilter"
              alt=""
              class="officialAccount smallProgram"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="search">
      <img
        src="@/assets/images/home/logo.png"
        alt=""
        @click="HeardeClick({ title: '首页', type: 99, path: '/', query: {} })"
        class="search-title"
      />
      <div v-if="meta.HeaderSearch" class="search-content">
        <div class="area area_all">
          <span class="area_name">全国</span>
          <img
            class="downArrow_icon"
            src="@/assets/images/home/downArrow.png"
            alt=""
          />
        </div>
        <div class="search-box">
          <div class="search-box_left" @click.stop="onMouseEnter">
            <span>{{ lineName }}</span>
            <img src="@/assets/images/home/downArrow.png" alt="" />
            <div
              class="search-box_left_posi"
              :style="{ display: lineShow ? 'block' : 'none' }"
            >
              <div
                v-for="(item, index) in lineList"
                :key="index"
                class="left_posi_item"
                @click="lineClick(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <el-input
            v-model="Value"
            placeholder="请输入内容"
            @focus.stop="searchFocus"
            @keyup.enter.native="recommendClick(Value)"
          ></el-input>
          <div class="search-box-text" @click="recommendClick(Value)">搜索</div>
          <div
            v-if="searchShow"
            @click.stop=""
            class="input_recommend"
            :style="{ display: searchShow ? 'block' : 'none' }"
          >
            <div class="recommend_name">历史搜索</div>
            <div
              class="recommend_item"
              v-for="(item, index) in history"
              :key="index"
              @click.stop="recommendClick(item.keyWord)"
            >
              <span>{{ item.keyWord }}</span>
              <div @click.stop="DeleteRecord(item)">
                <i class="el-icon-delete"></i>
              </div>
            </div>
            <div class="recommend_name" style="margin-top: 10px">热门搜索</div>
            <div class="host_box">
              <span
                class="host_box_name"
                v-for="(item, index) in host"
                :key="index"
                @click.stop="recommendClick(item.title)"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="search-box-right">在教育的路上 · 做路上的教育</div>
    </div>
    <div v-show="meta.HeaderTab" class="tab-box">
      <div
        v-for="(item, index) in HeardeTitle"
        :class="['area', item.type == HeardeIndex ? 'area_ative' : '']"
        @click.stop="HeardeClick(item)"
        :key="index"
      >
        <img
          v-if="item.type === 60"
          class="mall_icon"
          src="@/assets/images/home/Mall_icon.png"
          alt=""
        />
        <span
          :class="[
            'area_name',
            `${item.type}`,
            item.type === 60 ? 'select_area_name' : '',
          ]"
          @mouseenter="TitleMouseEnter"
          @mouseleave="TitleMouseLeave"
          >{{ item.title }}</span
        >
        <img
          v-if="item.type === 98"
          class="downArrow_icon"
          :src="mapShow ? IsDownArrowIcon : downArrowIcon"
          alt=""
        />
        <div
          class="area_tab"
          @mouseleave="handleMouseLeaves"
          v-show="item.type === 98 && mapShow"
        >
          <span @click.stop="mapClick(1)">全国境教地图</span>
          <!-- <span  @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave"
            >2D地图</span
          > -->
          <span @click.stop="mapClick(2)">珠海境教地图</span>
          <img
            v-show="mapShow2D"
            src="@/assets/images/home/map2d.jpg"
            class="area_qr"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import homes from '@/models/homes'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      Value: '',
      number: 1,
      searchType: 1,
      mapShow: false,
      mapShow2D: false,
      HeardeTitle: [
        { title: '首页', type: 99, path: '/', query: {} },
        // { title: '境教地图', type: 98 },
        {
          title: '商城专区',
          type: 60,
          path: '/shopPing'
        },
        {
          title: '还原地球',
          type: 1,
          path: '/childClassification',
          query: { id: 1 }
        },
        {
          title: '人文境教',
          type: 2,
          path: '/childClassification',
          query: { id: 2 }
        },
        {
          title: '时空历史',
          type: 3,
          path: '/childClassification',
          query: { id: 3 }
        },
        {
          title: '特质教育',
          type: 4,
          path: '/childClassification',
          query: { id: 4 }
        },
        {
          title: '一日活动',
          type: 8,
          path: '/reserve',
          query: { id: 1 }
        },
        {
          title: '定制游',
          type: 9,
          path: '/reserve',
          query: { id: 2 }
        },
        // { title: '主题游', type: 8 },
        // { title: '定制游', type: 9 },
        // { title: '国内游', type: 10 },
        { title: '名人堂', type: 12, path: '/hallFame', query: {} },
        { title: '游记攻略', type: 11, path: '/travelNotes', query: {} }
      ],
      lineList: [
        { title: '综合', type: 1 },
        { title: '线路', type: 2 },
        { title: '游记', type: 3 },
        { title: '攻略', type: 3 }
      ],
      HeardeIndex: 99,
      lineName: '综合',
      lineShow: false,
      searchShow: false,
      host: [],
      history: [],
      offmouseenterShow: false,
      offmouseenterShow2: false,
      offdownloadShow: false,
      smallProgramShow2: false,
      smallProgramShow: false,
      downArrowIcon: require('@/assets/images/home/downArrow.png'),
      IsDownArrowIcon: require('@/assets/images/home/isdownArrow.png'),
      QRofficialAccount: '',
      QRsmallProgram: '',
      QRweixing: '',
      QRcustomized: ''
    }
  },
  computed: {
    meta() {
      return this.$route.meta
    },
    ...mapState({
      token: state => state.user.token,
      userInfo: state => state.user.userInfo
    }),
    ...mapGetters(['token'])
  },
  mounted() {
    this.GetSearchPageData()
    this.GetQRCoderList()
  },
  methods: {
    async GetQRCoderList() {
      let res = await homes.QRCoderList()
      if (res.status === 200 && res.data.length > 0) {
        res.data.forEach(item => {
          if (item.qrCodeType === 1) {
            this.QRofficialAccount = item.qeCodeUrl
          } else if (item.qrCodeType === 3) {
            this.QRsmallProgram = item.qeCodeUrl
          } else if (item.qrCodeType === 2) {
            this.QRweixing = item.qeCodeUrl
          } else if (item.qrCodeType === 4) {
            this.QRcustomized = item.qeCodeUrl
          }
        })
      }
    },
    exit() {
      this.resultsToken()
      this.resultsUserInfo()
    },
    Jump(path, query) {
      this.$router.push({
        path: path,
        query: query
      })
      this.$emit('heardeChang', { path, query })
    },
    login(index) {
      this.$login.open(true, index)
    },
    boxClick() {
      this.mapShow2D = false
      if (this.searchShow) {
        this.searchShow = false
      }
      if (this.lineShow) {
        this.lineShow = false
      }
      if (this.mapShow) {
        this.mapShow = false
      }
      if (this.mapShow2D) {
        this.mapShow2D = false
      }
    },
    async GetSearchPageData() {
      let res = await homes.SearchPageData()
      if (res.status === 200) {
        this.host = res.data.host
        this.history = res.data.history
      }
    },
    searchFocus() {
      setTimeout(() => {
        this.searchShow = true
      }, 200)
    },
    HeardeClick(data) {
      this.HeardeIndex = data.type
      if (data.type === 98) {
        this.mapShow = true
        return
      }
      if (data.path) {
        this.$router.replace({
          path: data.path,
          query: data.query
        })
      }
    },
    onMouseEnter() {
      this.lineShow = !this.lineShow
      this.searchShow = false
    },
    lineClick(event) {
      this.lineName = event.title
      this.searchType = event.type
      // this.recommendClick(this.Value)
    },
    handleMouseOut() {},
    async DeleteRecord(data) {
      let res = await homes.UserSearchLog({ keyWord: data.keyWord })
      if (res.status === 200) {
        this.GetSearchPageData()
      }
    },
    recommendClick(data) {
      this.Value = data
      this.searchShow = false
      this.$router.replace({
        path: '/search/details',
        query: {
          keyWord: data,
          click: this.number++,
          searchType: this.searchType
        }
      })
      setTimeout(() => {
        this.GetSearchPageData()
      }, 1500)
    },
    mapClick(data) {
      if (!this.token) {
        this.login(1)
        return
      }
      if (data === 2) {
        // this.mapShow2D = true
        window.open(
          `https://workspace.easyv.cloud/shareScreen/eyJzY3JlZW5JZCI6MzA3NDI3MX0?mobile=${
            this.userInfo.mobile
          }&nickName=${this.userInfo.nickname}`
        )
      } else {
        window.open(
          `https://workspace.easyv.cloud/shareScreen/eyJzY3JlZW5JZCI6MzMxMzc4Mn0=?mobile=${
            this.userInfo.mobile
          }&nickName=${this.userInfo.nickname}`
        )
      }
      this.mapShow = false
    },
    handleMouseEnter() {
      this.mapShow2D = true
    },
    handleMouseLeave() {
      this.mapShow2D = false
    },
    handleMouseLeaves(event) {
      if (event.clientY > 176) {
        this.mapShow = false
      }
    },
    TitleMouseEnter(event) {
      if (event.target._prevClass.split(' ')[1] === '98') {
        this.mapShow = true
      }
    },
    TitleMouseLeave(event) {
      if (event.target._prevClass.split(' ')[1] === '98') {
        if (event.clientY > 159 && event.clientY < 168) {
          this.mapShow = true
        } else {
          this.mapShow = false
        }
      }
    },
    offmouseenter(data) {
      this.offmouseenterShow = data
    },
    offmouseenterV2(data) {
      this.offmouseenterShow2 = data
    },
    offdownload(data) {
      this.offdownloadShow = data
    },
    smallProgramV2(data) {
      this.smallProgramShow2 = data
    },
    smallProgram(data) {
      this.smallProgramShow = data
    },
    ...mapActions(['resultsToken', 'resultsUserInfo'])
  },
  watch: {
    '$route.fullPath': {
      handler(val) {
        if (val) {
          const match = val.match(/[?&]id=(\d+)/)
          this.HeardeTitle.forEach(item => {
            if (val.includes('/childClassification') && match) {
              this.HeardeIndex = match[1]
            } else if (val.includes('/reserve') && match) {
              if (item.query && match[1] == item.query.id) {
                this.HeardeIndex = item.type
              }
            } else if (val.includes(item.path)) {
              this.HeardeIndex = item.type
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  background-color: #fff;
  width: 100%;
  min-width: 1400px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 30;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 7px 6px 0px rgba(8, 48, 31, 0.24);
  .area_qr {
    position: absolute;
    left: 80px;
    bottom: -72px;
    width: 100px;
    height: 100px;
  }
  .heardes {
    display: flex;
    width: 100%;
    height: 25px;
    justify-content: center;
    align-items: center;
    background: #16ad4a;
    .heardeBox {
      min-width: 1400px;
      display: flex;
      font-size: 12px;
      justify-content: space-between;
      color: #fff;
      .heardes-text {
        margin: 0 10px;
        cursor: pointer;
      }
      .heardes-text-img {
        display: flex;
        align-items: center;
        position: relative;
        .heardes-icon {
          width: 16px;
          height: 17px;
          margin-left: 2px;
        }
        .officialAccount {
          width: 100px;
          height: 100px;
          position: absolute;
          top: 30px;
          left: -25px;
        }
        .smallProgram {
          background-color: #fff;
          top: 30px;
        }
      }
      .heardes-right {
        display: flex;
        align-items: center;
        .icon-item {
          width: 16px;
          height: 16px;
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
  }

  .search {
    width: 1400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0px;
    .search-title {
      cursor: pointer;
      width: 260px;
      height: 53px;
    }
    .search-content {
      display: flex;
      align-items: center;
      flex: 1;
      margin-left: 120px;
    }
    .search-box {
      width: 620px;
      height: 40px;
      border: 2px solid #16ad4a;
      border-radius: 8px 8px 8px 8px;
      margin-left: 30px;
      display: flex;
      position: relative;
      /deep/ .el-input__inner {
        flex: 1;
        border: none !important;
        height: 36px;
        font-size: 14px;
        padding-left: 0px;
      }
      .search-box_left {
        width: 80px;
        display: flex;
        align-items: center;
        position: relative;
        justify-content: center;
        font-size: 14px;
        font-weight: 300;
        color: rgba(0, 0, 0, 0.9);
        cursor: pointer;
        img {
          width: 10px;
          height: 10px;
          margin-left: 2px;
        }
        .search-box_left_posi {
          position: absolute;
          left: 0;
          top: 40px;
          width: 60px;
          background-color: #fff;
          border-radius: 0px 0px 4px 4px;
          .left_posi_item {
            width: 100%;
            text-align: center;
            font-size: 14px;
            padding: 4px 0;
          }
        }
      }
      .search-box-text {
        width: 130px;
        height: 36px;
        line-height: 40px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        background-color: #16ad4a;
        cursor: pointer;
      }
      .input_recommend {
        position: absolute;
        left: 0;
        top: 38px;
        width: 520px;
        padding-top: -50px;
        background-color: #fff;
        box-sizing: content-box;
        padding: 14px;
        box-sizing: border-box;
        border-radius: 0px 0px 8px 8px;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        z-index: 10;
        .el-icon-delete {
          cursor: pointer;
          height: 14px;
        }
        .recommend_name {
          font-size: 14px;
          font-weight: bold;
          color: #000;
        }
        .recommend_item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 4px 0px;
          font-size: 12px;
          color: #000;
          margin-top: 4px;
          span {
            cursor: pointer;
            flex: 1;
          }
        }
        .host_box {
          display: flex;
          flex-wrap: wrap;
          .host_box_name {
            margin: 8px 10px 0px 0px;
            cursor: pointer;
          }
        }
      }
    }
    .search-box-right {
      font-size: 18px;
      color: #16ad4a;
      font-weight: 600;
    }
  }
  .tab-box {
    width: 1400px;
    display: flex;
    justify-content: space-between;
  }
  .downArrow_icon {
    width: 12px;
    height: 14px;
    margin-top: 2px;
  }

  .area {
    display: flex;
    align-items: flex-start;
    padding: 0px 6px;
    position: relative;
    height: 40px;
    .mall_icon {
      width: 26px;
      height: 26px;
      margin-top: -3px;
    }
    .select_area_name {
      color: #ff9a0d !important;
    }
    .area_name {
      font-size: 14px;
      margin-right: 4px;
      cursor: pointer;
    }
    .area_name:hover {
      color: #16ad4a;
    }
    .area_tab {
      position: absolute;
      top: 40px;
      left: 0px;
      background-color: #fff;
      width: 100px;
      display: flex;
      flex-direction: column;
      box-shadow: 5px 5px 10px 2px rgba(0, 0, 0, 0.5);
      span {
        display: inline-block;
        height: 30px;
        line-height: 28px;
        font-size: 14px;
        color: #000;
        cursor: pointer;
        text-align: center;
        background-color: #fff;
      }
      span:hover {
        color: #fff;
        background-color: #16ad4a;
      }
    }
  }
  .area_all {
    height: auto;
  }
  .area_ative {
    color: #16ad4a;
  }
}
</style>
